import { ScreenWidthMinXLarge } from '@fluentui/react';
import { navCollapsedWidth } from '@m365-admin/nav';
import { getScrollBarWidth } from './CoherenceNav.utilities';
var headerHeight = 48;
var navWidth = 228;
var scrollBarWidth = 0;
var currentZoomLevel = 0;
export var getStyles = function (props) {
    var _a, _b, _c;
    var theme = props.theme, isNavCollapsed = props.isNavCollapsed, zoomLevel = props.zoomLevel;
    _a = getScrollBarWidth(scrollBarWidth, currentZoomLevel, zoomLevel), scrollBarWidth = _a[0], currentZoomLevel = _a[1];
    return {
        root: {
            position: 'fixed',
            top: headerHeight,
            bottom: 0
        },
        navContainer: {
            width: isNavCollapsed ? navCollapsedWidth + scrollBarWidth : navWidth + scrollBarWidth
        },
        outerNavWrapper: {
            selectors: (_b = {},
                _b["@media (max-width: " + ScreenWidthMinXLarge + "px)"] = {
                    display: 'none'
                },
                _b)
        },
        showNav: {
            display: 'block',
            position: 'absolute',
            top: headerHeight,
            left: 0,
            bottom: 0
        },
        mobileNavWrapper: {
            marginTop: 4,
            selectors: (_c = {},
                _c["@media (min-width: " + (ScreenWidthMinXLarge + 1) + "px)"] = {
                    display: 'none'
                },
                _c)
        },
        mobileNavTrigger: {
            marginLeft: 8,
            color: theme.palette.neutralPrimary,
            selectors: {
                ':hover, :active': {
                    color: theme.palette.neutralPrimary
                }
            }
        }
    };
};
//# sourceMappingURL=CoherenceNav.styles.js.map